<section class="bg-platinum py-16 sm:py-20">
  <div class="mx-auto max-w-3xl px-5">
    <div class="flex flex-col md:flex-row justify-between items-center gap-8">
      <h2 class="text-3xl text-center md:text-left font-bold tracking-tight text-white sm:text-4xl">
        Nominated for <span class="text-turquoise">Best Tech</span> at the 2025 iGB Affiliate Awards
      </h2>
      <div class="flex-shrink-0">
        <img src="https://imgix.cosmicjs.com/30f58350-5a82-11f0-ae5a-0f56aa053fcd-5baca3492a46b84e6ba4aadae36d761b65fcdc48.png?auto=format,compress&w=300" alt="rewards logo" width="150" height="150">
      </div>
    </div>
  </div>
</section>

<section class="bg-platinum py-16 sm:py-20">
  <div class="mx-auto max-w-5xl px-5">
    <div class="mx-auto max-w-4xl text-center">
      <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl">
        Why choose <span class="text-turquoise">Dimers Platinum?</span>
      </h2>
    </div>

    <div class="mx-auto mt-12 grid max-w-none grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
      <div *ngFor="let feature of features" class="bg-turquoise/10 rounded-xl p-5 card-hover-effect">
        <div class="">
            <img [src]="feature.iconUrl" alt="icon" width="32" height="32">
        </div>
        <h3 class="mt-6 font-semibold text-white">{{ feature.title }}</h3>
        <p class="mt-2 text-sm text-gray-300">{{ feature.description }}</p>
      </div>
    </div>
  </div>
</section>

<section class="bg-platinum py-16 sm:py-20">
  <div class="mx-auto max-w-5xl px-6 lg:px-8">
    <div class="mx-auto text-center">
      <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl">
        Real results from <span class="text-turquoise">real users</span>
      </h2>
    </div>

    <div class="mt-12 grid grid-cols-1 gap-4 md:grid-cols-3">
      <div *ngFor="let result of realResults" class="bg-turquoise/10 rounded-xl p-8 text-left card-hover-effect">
        <p class="text-lg font-semibold text-white">{{ result.label }}</p>
        <p class="mt-1 text-5xl font-bold tracking-tight text-white">{{ result.value }}</p>
      </div>
    </div>

    <p class="mt-8 text-center text-sm text-gray-300">
      Based on Dimers Platinum member survey results from the 2024 college football season.
    </p>
  </div>
</section>